/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IntentPayload } from '../models/IntentPayload';
import type { InvoiceResponse } from '../models/InvoiceResponse';
import type { PaymentAttemptPayload } from '../models/PaymentAttemptPayload';
import type { StripePaymentStatus } from '../models/StripePaymentStatus';
import type { StripeSessionIdPayload } from '../models/StripeSessionIdPayload';
import type { StripeSessionResponse } from '../models/StripeSessionResponse';
import type { SubscriptionPlansResponse } from '../models/SubscriptionPlansResponse';
import type { SubscriptionResponse } from '../models/SubscriptionResponse';
import type { SyncResult } from '../models/SyncResult';
import type { UpdateResult } from '../models/UpdateResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SubscriptionService {
    /**
     * Get Subscription
     * @returns SubscriptionResponse Successful Response
     * @throws ApiError
     */
    public static getSubscriptionApiSubscriptionActiveGet(): CancelablePromise<SubscriptionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/subscription/active',
        });
    }
    /**
     * Cancel Subscription
     * @param subscriptionId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static cancelSubscriptionApiSubscriptionCancelSubscriptionIdPost(
        subscriptionId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/cancel/{subscription_id}',
            path: {
                'subscription_id': subscriptionId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Plans
     * @returns SubscriptionPlansResponse Successful Response
     * @throws ApiError
     */
    public static listPlansApiSubscriptionPlansGet(): CancelablePromise<SubscriptionPlansResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/subscription/plans',
        });
    }
    /**
     * Activate Trial
     * @returns any Successful Response
     * @throws ApiError
     */
    public static activateTrialApiSubscriptionActivateTrialPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/activate-trial',
        });
    }
    /**
     * Create Stripe Session
     * @param requestBody
     * @returns StripeSessionResponse Successful Response
     * @throws ApiError
     */
    public static createStripeSessionApiSubscriptionStripeSessionPost(
        requestBody: IntentPayload,
    ): CancelablePromise<StripeSessionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/stripe-session',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Session Status
     * @param requestBody
     * @returns StripePaymentStatus Successful Response
     * @throws ApiError
     */
    public static updateSessionStatusApiSubscriptionStripeSessionStatusPost(
        requestBody: StripeSessionIdPayload,
    ): CancelablePromise<StripePaymentStatus> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/stripe-session-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Nowpayments Intent
     * @param requestBody
     * @returns InvoiceResponse Successful Response
     * @throws ApiError
     */
    public static createNowpaymentsIntentApiSubscriptionNowpaymentsIntentPost(
        requestBody: IntentPayload,
    ): CancelablePromise<InvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/nowpayments-intent',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Payment Status
     * @param requestBody
     * @returns UpdateResult Successful Response
     * @throws ApiError
     */
    public static updatePaymentStatusApiSubscriptionNowpaymentStatusPost(
        requestBody: PaymentAttemptPayload,
    ): CancelablePromise<UpdateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/nowpayment-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sync From Revenuecat
     * Called by the iOS app right after a successful Purchases.purchasePackage()
     * or Purchases.restorePurchases(). Fetches the user's CustomerInfo from
     * @returns SyncResult Successful Response
     * @throws ApiError
     */
    public static syncFromRevenuecatApiSubscriptionSyncFromRevenuecatPost(): CancelablePromise<SyncResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/subscription/sync-from-revenuecat',
        });
    }
}
